import type { Theme } from '@mui/material/styles';

import { TypographyVariant } from '../../theme/types';
import { AvatarVariants } from './types';

export const avatarVariantToSizeMap: Record<AvatarVariants, number> = {
  'lg': 42,
  'md': 32,
  'sm': 24,
  'xs': 16,
};

export const avartarVariantToTypographyMap: Record<
  AvatarVariants,
  TypographyVariant
> = {
  'lg': 'font20',
  'md': 'font14Bold',
  'sm': 'font11',
  'xs': 'font11',
};

/**
 * Taking any string, return values for background, foreground color
 */
export function stringToColor(
  string: string,
  theme: Theme,
): {
  backgroundColor: string;
  color: string;
} {
  const avatarColorOptions = {
    blue: {
      backgroundColor: theme.palette.colors.blue[200],
      color: theme.palette.colors.blue[700],
    },
    green: {
      backgroundColor: theme.palette.colors.green[200],
      color: theme.palette.colors.green[700],
    },
    red: {
      backgroundColor: theme.palette.colors.red[100],
      color: theme.palette.colors.red[700],
    },
    yellow: {
      backgroundColor: theme.palette.colors.yellow[200],
      color: theme.palette.colors.yellow[800],
    },
  };

  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  const options = Object.values(avatarColorOptions);
  const idx = Math.abs(hash % options.length);
  return options[idx];
}

export function stringAvatar(name: string, variant: AvatarVariants): string {
  const splitOnSpaces = name.split(' ');
  return splitOnSpaces.length === 1 || variant === 'xs'
    ? splitOnSpaces[0][0]
    : `${splitOnSpaces[0][0]}${splitOnSpaces[1][0]}`;
}
